var Backbone, EmailFormUSUserIdentificationView, GrouponValidate, SupportUserIdentificationTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GrouponValidate = require("../../../../../groupon/frontend/validate");

Backbone = require('backbone');

Backbone.$ = $;

SupportUserIdentificationTemplate = require('../../../../user_identification.html.mustache');

EmailFormUSUserIdentificationView = (function(superClass) {
  extend(EmailFormUSUserIdentificationView, superClass);

  function EmailFormUSUserIdentificationView() {
    return EmailFormUSUserIdentificationView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSUserIdentificationView.prototype.className = 'requestedFields';

  EmailFormUSUserIdentificationView.prototype.tagName = 'li';

  EmailFormUSUserIdentificationView.prototype.events = {
    'keyup #tcktUsername': 'checkUserId',
    'keyup #tcktUsermail': 'checkMailId'
  };

  EmailFormUSUserIdentificationView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.model = this.options.model;
    this.isInputCompulsory = this.model.required;
    return this.template = SupportUserIdentificationTemplate;
  };

  EmailFormUSUserIdentificationView.prototype.getUsernameElement = function() {
    return this.$el.find('#tcktUsername');
  };

  EmailFormUSUserIdentificationView.prototype.getEmailIdElement = function() {
    return this.$el.find('#tcktUsermail');
  };

  EmailFormUSUserIdentificationView.prototype.checkUserId = function() {
    return this.enableDisableSubmitButton();
  };

  EmailFormUSUserIdentificationView.prototype.checkMailId = function() {
    var email_id;
    this.enableDisableSubmitButton();
    email_id = this.getEmailIdElement().val().trim();
    if (GrouponValidate.email(email_id)) {
      return $('#validateUserContactEmail').css('display', 'none');
    }
  };

  EmailFormUSUserIdentificationView.prototype.enableDisableSubmitButton = function() {
    return this.options.validateEmailForm.call();
  };

  EmailFormUSUserIdentificationView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormUSUserIdentificationView.prototype.toHash = function() {
    return {
      isLoggedIn: typeof currentUser !== "undefined" && currentUser !== null,
      is_email: (typeof currentUser !== "undefined" && currentUser !== null ? currentUser.email : void 0) != null
    };
  };

  EmailFormUSUserIdentificationView.prototype.populateInput = function(data) {
    var ref, ref1, ref2, ref3;
    data.user_name = (ref = this.getUsernameElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    data.user_email = (ref2 = this.getEmailIdElement()) != null ? (ref3 = ref2.val()) != null ? ref3.trim() : void 0 : void 0;
    return data.userIdenficiationView = true;
  };

  EmailFormUSUserIdentificationView.prototype.validateEmailId = function() {
    var email_id, ref, ref1;
    email_id = (ref = this.getEmailIdElement()) != null ? (ref1 = ref.val()) != null ? ref1.trim() : void 0 : void 0;
    if (GrouponValidate.email(email_id)) {
      $('#validateUserContactEmail').css('display', 'none');
      return true;
    } else {
      $('#validateUserContactEmail').css('display', 'block');
      return false;
    }
  };

  EmailFormUSUserIdentificationView.prototype.isInputValid = function() {
    return this.validateEmailId();
  };

  EmailFormUSUserIdentificationView.prototype.isInputGiven = function() {
    var isvalid, ref, ref1, ref2, ref3, ref4, ref5;
    isvalid = true;
    if (((ref = this.getUsernameElement()) != null ? ref.length : void 0) > 0) {
      isvalid = ((ref1 = this.getUsernameElement()) != null ? (ref2 = ref1.val()) != null ? ref2.trim().length : void 0 : void 0) > 0;
    }
    if (isvalid && ((ref3 = this.getEmailIdElement()) != null ? ref3.length : void 0) > 0) {
      isvalid = isvalid && ((ref4 = this.getEmailIdElement()) != null ? (ref5 = ref4.val()) != null ? ref5.trim().length : void 0 : void 0) > 0;
    }
    return isvalid;
  };

  EmailFormUSUserIdentificationView.prototype.close = function() {};

  return EmailFormUSUserIdentificationView;

})(Backbone.View);

module.exports = EmailFormUSUserIdentificationView;

//# sourceMappingURL=data:application/json;base64,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
